import React from 'react';
import { LockKeyhole } from 'lucide-react';

const ConfidentialProjects = () => {
  return (
    <section className="py-16 bg-gray-50 rounded-lg">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6 flex justify-center">
            <div className="bg-blue-100 p-4 rounded-full">
              <LockKeyhole size={40} className="text-blue-700" />
            </div>
          </div>
          
          <h2 className="text-3xl font-bold mb-6">Weitere Referenzprojekte</h2>
          
          <p className="text-lg text-gray-700 mb-6">
            Neben den hier präsentierten Projekten haben wir zahlreiche weitere Agenturarbeiten und 
            interne Softwarelösungen entwickelt, die wir aufgrund von Verschwiegenheitsvereinbarungen 
            leider nicht öffentlich vorstellen dürfen.
          </p>
          
          <p className="text-lg text-gray-700">
            Sprich uns gerne an, wenn du mehr über unsere Expertise in 
            bestimmten Branchen oder Technologien erfahren möchtest. Wir teilen 
            unser Know-how und unsere Erfahrung – selbstverständlich im Rahmen 
            unserer Vertraulichkeitsverpflichtungen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConfidentialProjects; 